import React from 'react';
const LEVELS = [{
  title: 'Nivel 1 — Inicial',
  color: 'text-familia-gold',
  items: ['Ejercicios en silla o cama y estimulación básica.']
}, {
  title: 'Nivel 2 — Medio',
  color: 'text-familia-accent',
  items: ['Fuerza, equilibrio y actividades de lógica cotidiana.']
}, {
  title: 'Nivel 3 — Avanzado',
  color: 'text-white',
  items: ['Coordinación, resistencia suave y desafíos mentales.']
}];
export const VipModuleSection = () => {
  return <section id="vip" className="bg-familia-dark py-12 md:py-16 px-4 md:px-6 overflow-hidden" data-id="element-312" data-mp="1x7rbdo4w18dw">
      <div className="max-w-7xl mx-auto w-full" data-id="element-313" data-mp="1sa7t8d52kbgo">
        <div className="text-center mb-8 md:mb-14" data-id="element-314" data-mp="26xszgfx8qqst">
          <h2 className="text-[26px] sm:text-3xl md:text-5xl font-display font-bold text-white mb-4 md:mb-6 leading-tight" data-id="element-315" data-mp="26zds1zzzvzo1">
            ⚡ Módulo VIP —{' '}
            <span className="text-familia-accent" data-id="element-316" data-mp="1eg6vnmpusuhw">
              +150 ejercicios físicos y cognitivos
            </span>
          </h2>
          <p className="text-body text-familia-onDarkMuted max-w-3xl mx-auto" data-id="element-317" data-mp="19hn6ldfyr2lb">
            Más de 150 actividades organizadas en 3 niveles para adaptar la
            rutina a las posibilidades reales de tu familiar.
          </p>
        </div>
        <div className="no-scrollbar flex overflow-x-auto snap-x snap-mandatory gap-3 -mx-4 px-4 scroll-px-4 md:mx-0 md:px-0 md:overflow-visible md:grid md:grid-cols-3 md:gap-6" data-id="element-318" data-mp="2ltezfxqb5iw0">
          {LEVELS.map(level => <div key={level.title} className="snap-start shrink-0 w-[80%] md:w-auto bg-familia-darkCard border border-familia-darkBorder p-6 md:p-8 rounded-2xl" data-id="element-319" data-mp="1u2hc796pmqhx">
              <h3 className={`text-xl md:text-2xl font-bold mb-5 ${level.color}`} data-id="element-320" data-mp="1y5ng4a6co5l8">
                {level.title}
              </h3>
              <ul className="space-y-4" data-id="element-321" data-mp="281gxc6v0kn9c">
                {level.items.map(item => <li key={item} className="flex items-start gap-3 text-body text-white/90" data-id="element-322" data-mp="27znsmx3yod3z">
                    <span className={`${level.color} shrink-0`} aria-hidden="true" data-id="element-323" data-mp="3ejx4336ojsbj">
                      →
                    </span>
                    <span data-id="element-324" data-mp="2tsi48rwfp5in">{item}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
        <p className="text-body text-white font-semibold text-center max-w-2xl mx-auto mt-8 md:mt-10" data-id="element-325" data-mp="2ou6ueh652v0f">
          Así nunca le das algo demasiado fácil (se aburre) ni demasiado difícil
          (se frustra).
        </p>
      </div>
    </section>;
};